import head from 'lodash/head'
import dotProp from 'dot-prop-immutable'

function sizeMatch(size) {
  return function(frame) {
    return (
      (frame.width === size.width && frame.height === size.height) ||
      (frame.width === size.height && frame.height === size.width)
    )
  }
}

export default function(frames, { width, height }) {
  const result = frames.filter(sizeMatch({ width, height }))
  if (result.length === 0) {
    return []
  }

  return dotProp.get(head(result), 'colors', [])
}



// WEBPACK FOOTER //
// ./src/containers/CollectionColors/findColor.js